import React from 'react'
import { FormSection, RouteGroup } from '@cicero/ui'
import { ChartsSection, DecorativeSection, DraggableSection, LayoutSection } from '@cicero/ui/__demo__/ComponentDemos'
import { AttributeSettings, TemplateSettings, UserSettings } from '../user/settings'
import { DebugPage } from './DebugPage'

export const SettingsPage = () => {
  return <RouteGroup
    routes={
      [
        { label: 'User Settings' },
        { label: 'Account Settings', details: { path: '/settings', component: SettingsHome } },
        { label: 'Notification Settings', details: { path: '/settings/notifications', component: SettingsNotifications } },
        { label: 'Organization Settings', details: { path: '/settings/organizations', component: SettingsOrganizations } },

        { label: 'Admin' },
        { label: 'Data Debug', details: { path: '/settings/debug', component: DebugPage } },
        { label: 'UI Components', details: { path: '/settings/debug/components', component: ComponentSection } },
      ]
    }
  />
}

const SettingsHome = () => {
  return <>
    <UserSettings />
    <TemplateSettings />
    <AttributeSettings />
  </>
}

const SettingsNotifications = () => {
  return <FormSection title="Notifications"></FormSection>
}

const SettingsOrganizations = () => {
  return <FormSection title="Organizations"></FormSection>
}

const ComponentSection = () => {
  return <>
    <DecorativeSection />
    <LayoutSection />
    <ChartsSection />
    <DraggableSection />
  </>
}
